<template>
    <div class="deeplinkWrapper d-flex justify-content-center align-items-center">
        <template v-if="shouldOpenMobileApp">
            <div v-if="link !== null">
                <div
                    v-if="isRegisterViaEmail"
                    class="vc-completed">
                    <div class="vc-completed__welcome">
                        <img class="vc-completed__welcome-img" src="/images/common/register_completed_01.jpg">
                        <p class="vc-completed__welcome-text mb-0">{{ $locale.appName }}オンライン医療相談サービスへようこそ！<br>ご登録のメールアドレスに確認メールを送信しました。</p>
                    </div>
                </div>

                <div class="text-center">
                    <a
                        id="launchBtn"
                        class="deeplinkAppLaunchButton mb-5"
                        :class="{ 'deeplinkAppLaunchButtonConsul' : $locale.type === 'consul' }"
                        :href="link">
                        {{ $locale.appName }}アプリを起動
                    </a>
                    <div class="mb-4 mt-5">
                        <img src="images/common/basic_logo_default.png" width="100">
                    </div>
                    <div>
                        <div>アプリをまだインストールされていない方は</div>
                        <a
                            v-if="$locale.type === 'consul'"
                            href="https://apps.apple.com/jp/app/id1625616546">
                            アプリをダウンロード
                        </a>
                        <a
                            v-else
                            href="https://apps.apple.com/jp/app/id1519400662">
                            アプリをダウンロード
                        </a>
                    </div>
                </div>
            </div>
            <div v-else>
                <b-spinner variant="yokumiru-user"/>
            </div>
        </template>
        <template v-else>
            <b-spinner variant="yokumiru-user"/>
        </template>
    </div>
</template>

<script>
import YokumiruHelper from '../../YokumiruHelper'
import { mapMutations } from 'vuex'

export default {
    props: {
        agent: {
            type: String,
            required: true,
        },
        urlScheme: {
            type: String,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            link: null,
        }
    },

    computed: {
        action: function () {
            return this.$route.query.action || null
        },

        action_meta: function () {
            return this.$route.query.action_meta || null
        },

        consultation_id: function () {
            return this.$route.query.consultation_id || null
        },

        doctor_id: function () {
            return this.$route.query.doctor_id  || null
        },

        medical_course_id: function () {
            return this.$route.query.medical_course_id || null
        },

        doctor_menu_id: function () {
            return this.$route.query.doctor_menu_id  || null
        },

        start_date: function () {
            return this.$route.query.start_date || null
        },

        start_time: function () {
            return this.$route.query.start_time || null
        },

        token: function () {
            return this.$route.query.token || null
        },

        device_id: function () {
            return this.$route.query.device_id || null
        },

        auth_token: function () {
            return this.$route.query.auth_token || null
        },

        access_token: function () {
            return this.$route.query.access_token || null
        },

        expires_at: function () {
            return this.$route.query.expires_at || null
        },

        auth_type: function () {
            return this.$route.query.auth_type || null
        },

        hide_header: function () {
            return this.$route.query.hide_header || null
        },

        error: function () {
            return this.$route.query.error || null
        },

        /**
         * 相談室のアクション（デフォルトで開くタブ毎にaction名が異なる）
         *
         * @see https://github.com/sewii/yokumiru_mobile/issues/395#issue-1306293269
         * @return {array}
         */
        consultationActions: function () {
            return [
                'consultation_video',
                'consultation_chat',
                'consultation_interview',
                'consultation_medical_record',
                'consultation_image',
                'consultation_attached_image',
            ]
        },

        /**
         * action判定:【請求履歴】
         * @return {boolean}
         */
        isInvoices: function () {
            return this.action === 'invoices'
        },

        /**
         * action判定:【予約フロー: 医師ページ】
         * @return {boolean}
         */
        isReservationDoctor: function () {
            return this.action === 'reservation_doctor'
        },

        /**
         * action判定:【予約フロー: メニュー一覧】
         * @return {boolean}
         */
        isReservationMenu: function () {
            return this.action === 'reservation_menu'
        },

        /**
         * action判定:【予約フロー: メニュー詳細】
         * @return {boolean}
         */
        isReservationMenuDetail: function () {
            return this.action === 'reservation_menu_detail'
        },

        /**
         * action判定:【相談室】
         * @return {boolean}
         */
        isConsultation: function () {
            return this.consultationActions.includes(this.action)
        },

        /**
         * action判定:【クーポン入力】
         * @return {boolean}
         */
        isAddCoupon: function () {
            return this.action === 'add_coupon'
        },

        /**
         * action判定:【メールアドレス認証】
         * @return {boolean}
         */
        isEmailVerify: function () {
            return this.action === 'email_verify'
        },

        /**
         * action判定:【ヘルスアンサー回答】
         * @return {boolean}
         */
        isHealthSurveyAnswer: function () {
            return this.action === 'health_survey_answer'
        },

        /**
         * action判定:【ソーシャルログインのOAuth2承認後リダイレクト（アプリ版用）】
         * @return {boolean}
         */
        isOauthCompleted: function () {
            return this.action === 'oauth_completed'
        },

        /**
         * メールアドレス経由の会員登録かどうか
         * @return {boolean}
         */
        isRegisterViaEmail: function () {
            return this.action_meta === 'register_via_email'
        },

        /**
         * クエリパラメータの構築
         *
         * @see https://github.com/sewii/yokumiru_mobile/issues/395#issue-1306293269
         * @return {string}
         */
        buildQuery: function () {
            if (!this.action) return ''

            let q = `?action=${this.action}`
            let params = ''

            if (this.isInvoices) {
                // パラメータ無し
            }
            else if (this.isReservationDoctor) {
                params = `&doctor_id=${this.doctor_id}`
            }
            else if (this.isReservationMenu) {
                params = `&medical_course_id=${this.medical_course_id}`
                if (this.start_date) {
                    params += `&start_date=${this.start_date}`
                    if (this.start_time) {
                        params += `&start_time=${this.start_time}`
                    }
                }
            }
            else if (this.isReservationMenuDetail) {
                params = `&medical_course_id=${this.medical_course_id}&doctor_menu_id=${this.doctor_menu_id}`
                if (this.start_date) {
                    params += `&start_date=${this.start_date}`
                    if (this.start_time) {
                        params += `&start_time=${this.start_time}`
                    }
                }
                if (this.doctor_id) {
                    params += `&doctor_id=${this.doctor_id}`
                }
            }
            else if (this.isConsultation) {
                params = `&consultation_id=${this.consultation_id}`
            }
            else if (this.isAddCoupon) {
                // パラメータ無し
            }
            else if (this.isEmailVerify) {
                params = `&token=${this.token}`
            }
            else if (this.isHealthSurveyAnswer) {
                if (this.access_token) {
                    params += `&access_token=${this.access_token}`
                }
                if (this.hide_header) {
                    params += `&hide_header=${this.hide_header}`
                }
            }
            else if (this.isOauthCompleted) {
                params = `&device_id=${this.device_id}&auth_token=${this.auth_token}&access_token=${this.access_token}&expires_at=${this.expires_at}&auth_type=${this.auth_type}&error=${this.error}`
            }

            return `${q}${params}`
        },

        urlWeb: function () {
            if (this.isInvoices) {
                return '/invoices'
            }
            else if (this.isReservationDoctor) {
                return '/home'
            }
            else if (this.isReservationMenu) {
                return '/home'
            }
            else if (this.isReservationMenuDetail) {
                return '/home'
            }
            else if (this.isConsultation) {
                return `/consultations/${this.consultation_id}`
            }
            else if (this.isAddCoupon) {
                return '/user_coupons'
            }
            else if (this.isEmailVerify) {
                return '/email/verify'
            }
            else if (this.isHealthSurveyAnswer) {
                return '/health_surveys'
            }
            else if (this.isOauthCompleted) {
                // アプリ版用の処理なのでWeb用のURLは不要（'/' としておく）
                return '/'
            }
            else {
                return '/'
            }
        },

        /**
         * アプリ版を開く判定
         */
        shouldOpenMobileApp: function () {
            // @todo issue/501 isEmailVerify はアプリ版実装まで一時的にWeb版固定遷移とする
            if (this.isEmailVerify) {
                return false
            }

            return this.agent === 'ios' || this.agent === 'android'
        },
    },

    watch: {
        link: function (value) {
            // ログイン・会員登録の場合は自動でボタン押下（メールアドレスでの会員登録だけは対象外）
            if (value && this.shouldOpenMobileApp && this.isOauthCompleted && !this.isRegisterViaEmail) {
                setTimeout(() => document.getElementById('launchBtn').click(), 300)
            }
        },
    },

    mounted: function () {
        if (this.shouldOpenMobileApp) {
            this.link = `${this.urlScheme}://${this.buildQuery}`
        }
        else {
            this.pushAnalyticsDataLayer()
            this.link = `${this.urlWeb}${this.buildQuery}`
            if (this.action) {
                // 未ログインでthis.linkが開けなかったとき用に保持（ログイン後の UserDashboard.vue で再リダイレクトする）
                this.setPreviousDeeplink(this.link)
            }
            window.location.href = this.link
        }
    },

    methods: {
        ...mapMutations({
            setPreviousDeeplink: 'userMode/setPreviousDeeplink',
        }),

        /**
         * GoogleAnalytics GA4 カスタムイベント発火
         */
        pushAnalyticsDataLayer: function () {
            if (this.$locale.type !== 'consul') return

            if (this.isReservationDoctor) {
                // @see https://github.com/sewii/Yokumiru/issues/641
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__deeplinkDoctor',
                    doctorId: this.doctor_id,
                })
            }
            else if (this.isReservationMenuDetail) {
                // @see https://github.com/sewii/Yokumiru/issues/639
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__deeplinkDoctorMenuDetail',
                    doctorMenuId: this.doctor_menu_id,
                    doctorId: this.doctor_id,
                    medicalCourseId: this.medical_course_id,
                })
            }
        },
    },
}
</script>

<style scoped lang="scss">
.deeplinkWrapper {
    width: 100vw;
    height: calc(100vh - 120px);
}

.deeplinkAppLaunchButton {
    display: block;
    width: 210px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background-color: #05A1C3;
    border: none;
    border-radius: 8px;
    cursor: pointer;

    &.deeplinkAppLaunchButtonConsul {
        background-color: #CF798A;
    }
}

.vc-completed {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    max-width: 860px;
    padding: 0 30px;
    margin: 0 auto;
    box-sizing: border-box;

    @media screen and (max-width: 767px) {
        padding: 0 15px;
    }

    .vc-completed__welcome-img {
        max-width: 100%;
        margin: 30px 0 40px;

        @media screen and (max-width: 767px) {
            margin: 15px 0 20px;
        }
    }

    .vc-completed__welcome {
        margin-bottom: 40px;

        @media screen and (max-width: 767px) {
            margin-bottom: 23px;
        }

        .vc-completed__welcome-text {
            font-size: 16px;
            text-align: center;

            @media screen and (max-width: 767px) {
                font-size: 13px;
            }
        }
    }
}
</style>
